import { AppStoreSlice } from 'src/store/store';
import { LearningsStateSlice, LearningsState } from './types';

/**
 * Initial empty learnings state.
 */
const initialState: LearningsState = {
  learningsData: [],
  lastFetched: undefined,
};

/**
 * createLearningsSlice.
 * Initializes the state and action reducers for the learnings data slice.
 *
 * @param set Central store setter callback.
 * @returns The initialized slice object.
 */
export const createLearningsSlice: AppStoreSlice<LearningsStateSlice> = (
  set,
) => ({
  ...initialState,
  updateLearnings: (learnings) =>
    set((state) => {
      state.Learnings.learningsData = learnings;
      state.Learnings.lastFetched = Date.now();
    }),
  removeLearnings: () => {
    set((state) => {
      state.Learnings.learningsData = initialState.learningsData;
      state.Learnings.lastFetched = undefined;
    });
  },
});

export default createLearningsSlice;
